/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#nav-link-space[_ngcontent-%COMP%]{margin-right:15px!important}"];
export { styles as styles };
